// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"56ef5592","20":"c6c6a24d","41":"333fd6d2","150":"52de3063","407":"bcc07fef","996":"2cb05111"}[chunkId] + ".chunk.js";
};